import { createAction, props, union } from '@ngrx/store';
import { CheckoutStep } from '@arc/unified-payments-frontend/shared-payment';

export const CurrentCheckoutStepChangedAction = createAction(
  '[Payment Footer] Current Checkout Step Action',
  props<{
    payload: {
      currentStep: CheckoutStep;
    };
  }>(),
);

export const ExecuteProceedToPaymentAction = createAction(
  '[Payment Footer] Execute Proceed To Payment Action',
);

export const ExecuteBackFromSelectPaymentTypeAction = createAction(
  '[Payment Footer] Execute Back From Select Payment Type Action',
);

export const ExecuteBackFromSelectPaymentMethodAction = createAction(
  '[Payment Footer] Execute Back From Select Payment Method Action',
);

export const ExecuteBackFromConfirmPaymentAction = createAction(
  '[Payment Footer] Execute Back From Confirm Payment Action',
);

export const ExecuteReviewPaymentAction = createAction(
  '[Payment Footer] Execute Review Payment Action',
);

export const ExecuteBackFromReviewPaymentAction = createAction(
  '[Payment Footer] Execute Back From Review Payment Action',
);

export const ExecuteAuthorizePaymentAction = createAction(
  '[Payment Footer] Execute Authorize Payment Action',
);

export const ExecuteReturnToAppAction = createAction(
  '[Payment Footer] Execute Proceed To App Action',
);

export const ExecuteSessionExitAction = createAction(
  '[Payment Footer] Execute Session Exit Action',
);

export const CurrentStepValidationFailed = createAction(
  '[Payment Footer] Current Step Validation Failed Action',
);

export const GetTranslationsSuccess = createAction(
  '[Payment Footer] Get Translations Success',
  props<{ translations: Record<string, string> }>(),
);

const PaymentFooterActions = union({
  CurrentCheckoutStepChangedAction,
  ExecuteProceedToPaymentAction,
  ExecuteBackFromSelectPaymentTypeAction,
  ExecuteBackFromSelectPaymentMethodAction,
  ExecuteBackFromReviewPaymentAction,
  ExecuteBackFromConfirmPaymentAction,
  ExecuteReviewPaymentAction,
  ExecuteAuthorizePaymentAction,
  ExecuteReturnToAppAction,
  ExecuteSessionExitAction,
  CurrentStepValidationFailed,
  GetTranslationsSuccess,
});

export type PaymentFooterActionsUnion = typeof PaymentFooterActions;
